/**
 * Main app functions
 *
 * @package    [Site Name Here]
 * @copyright  Copyright (c) 2016 Synapse Marketing Solutions (http://www.synapseresults.com)
 * @version    1.0.0
 * @since      1.0.0
 */

if (typeof ($) === 'undefined') {
	var $ = jQuery;
}

/*************************************************************************************
 * Global Vars
 *************************************************************************************/
var win = $(window),
	doc = $(document);

var $tabbed_content, $scrolled_content, $flyout_menu, $forms, $nav, $mobile_nav, $sliders, $sitemap, $filterMenu, $loadIn;

$tabbed_content = {
	rotateHandler: null,
	gallery: $('.tab.is-active .gallery'),
	// mobile_tab_select_fix: function () {
	// 	$gallery = $('.tab:visible').find('.gallery').length;
	// 	if (!$gallery) {
	// 		$('.tab-content').css('padding', '15em 3em 2em 3em');
	// 		$('.tab-select.mobile').css('top','50px');
	// 	} else {
	// 		$('.tab-content').css('padding', '200px 3em 2em 3em');
	// 		$('.tab-select.mobile').css('top','450px');
	// 	}
	// },
	load: function () {
		var $hash;

		$hash = window.location.hash;

		if ($('body').hasClass("about") && ($hash === null || $hash === '')) {
			$hash = 'about-us';
		}

		if ($hash) {
			$hash = $hash.replace('#', '');

			$('.tab-select').velocity('transition.fadeIn', {
				duration: 1000,
				delay: 1200
			});
			$('[data-select-name]').removeClass('is-active');

			$('[data-tab="' + $hash + '"]').addClass('is-active');
			$('[data-select-name="' + $hash + '"]').addClass('is-active');
			// $('.tab-menu').hide();
			// $('[data-tab]').removeClass('is-active');
			// $('[data-tab-button="'+$hash+'"]').addClass('is-active');
			// $('.tab-wrap').removeClass('has-menu');

			$scrolled_content.init();
			$tabbed_content.gallery_rotate();
			$('[data-tab="' + $hash + '"] .module > *').velocity('transition.slideDownIn', {
				duration: 1000,
				delay: 200,
				stagger: 150,
				drag: false
			});
		} else {

			$('.tab-wrap .tab:first-of-type').addClass('is-active').find('.slide').addClass('is-active');
			$('[data-select-name]:first-of-type').addClass('is-active');
			$('.tab-select').velocity('transition.fadeIn', {
				duration: 1000,
				delay: 1200
			});

			// if ($('.tab-wrap').hasClass('has-menu')) {
			// 	$('[data-tab]').removeClass('is-active');
			// } else {
			// 	$('[data-tab="'+$hash+'"]').addClass('is-active');
			// 	$('.tab-wrap .tab:first-of-type').addClass('is-active').find('.slide').addClass('is-active');
			// }
			$('[data-tab].is-active .module > *').velocity('transition.slideDownIn', {
				duration: 1000,
				delay: 1200,
				stagger: 150,
				drag: false
			});
		}
	},
	action: function () {
		/*
		$('[data-tab-menu-name]').on('click touchstart', function(e) {
			if (!$(this).attr('href')) { // this checks to see if the page has child pages that are a tags.
				$name = $(this).data('tab-menu-name');
				$(this).parents('.tab-menu').fadeOut();
				window.location.hash = $name;
				$('.tabbed-content .tab-select').fadeIn();
				$('[data-tab="'+$name+'"]').addClass('is-active');
				$('[data-select-name="'+$name+'"]').addClass('is-active');
				$('.tab-select').addClass('is-active');
				$('.tab-wrap').removeClass('has-menu');
				$scrolled_content.init();
				$tabbed_content.gallery_rotate();
				$('[data-tab].is-active .module > *').velocity( 'transition.slideDownIn' , { duration: 1000, delay: 200, stagger : 150, drag : false });
			}
		}); */



		$('[data-select-name]').on('click touchstart', function (e) {
			e.preventDefault();
			if (!$(this).hasClass('is-active')) {
				var $name;

				clearInterval($tabbed_content.rotateHandler);

				$name = $(this).data('select-name');

				// if ($(this).hasClass('is-active')) {
				// 	if ($('body').hasClass('single-syn_results')) {

				// 	} else {
				// 		$('.tab-menu').fadeIn();
				// 		$('.tab-select').removeClass('is-active').fadeOut();
				// 		$('[data-tab="'+$name+'"]').removeClass('is-active');
				// 		$('[data-select-name="'+$name+'"]').removeClass('is-active');
				// 		window.location.hash = '';
				// 		$scrolled_content.init();
				// 	}

				// } else {
				// window.location.hash = $name;
				$('[data-select-name]').removeClass('is-active');
				$('[data-select-name="' + $name + '"]').addClass('is-active');
				$('[data-tab]').removeClass('is-active');
				$('[data-tab="' + $name + '"]').addClass('is-active');
				$scrolled_content.init();
				$tabbed_content.gallery_rotate();
				// }

				$('[data-tab].is-active .module > *').velocity('transition.slideDownIn', {
					duration: 1000,
					delay: 200,
					stagger: 150,
					drag: false
				});
				// $('.tab[data-tab]:not(.is-active) .tab-content').scrollTop(0);
				$('.tab[data-tab]:not(.is-active) .module > *').css({
					opacity: ''
				});
				if ($(this).parents('div').hasClass('mobile')) {
					// setTimeout(function() {
					$headerH = $('header').height();
					$('html, body').animate({
						scrollTop: $('.tabbed-content').offset().top - $headerH - 75
					}, 350);
					// }, 250);
				}
			}
		});

		/*
		if ($('[data-tab].is-active').find('.gallery').length) {
			$('body').addClass('has-gallery');
		} else {
			$('body').removeClass('has-gallery');
		}
		$('#tab-select').on('change', function() {
			$headerH = $('header').height();
			$name = $(this).val();
			window.location.hash = $name;
			$('[data-select-name]').removeClass('is-active');
			$('[data-select-name="'+$name+'"]').addClass('is-active');
			$('[data-tab]').removeClass('is-active');
			$('[data-tab="'+$name+'"]').addClass('is-active');
			$('html, body').animate({
			    scrollTop: $('.tabbed-content').offset().top - $headerH - 75
			}, 250);
			if ($('[data-tab="'+$name+'"]').find('.gallery').length) {
				$('body').addClass('has-gallery');
			} else {
				$('body').removeClass('has-gallery');
			}
			$tabbed_content.gallery_rotate();
			// $tabbed_content.mobile_tab_select_fix();
			$('[data-tab].is-active .module > *').velocity( 'transition.slideDownIn' , { duration: 1000, delay: 200, stagger : 150, drag : false });
		});
		*/

	},
	auto_rotate_content: function () {
		var $timerSpeed, $pauseTimer;

		$timerSpeed = 5500;
		$pauseTimer = false;

		function rotate() {
			var $current;

			if ($pauseTimer === false) {
				$current = $('body.single-syn_results .light-arrow .tab-select-name.is-active, body.page-template-main-slider .light-arrow .tab-select-name.is-active');
				if ($current.next().length) {
					$current.next().trigger('click');
				} else {
					$('body.single-syn_results .light-arrow .tab-select-name, body.page-template-main-slider .light-arrow .tab-select-name').eq(0).trigger('click');
				}
				// console.log('running');
			}
		}

		function startRotate() {
			setInterval(function(){
				rotate();
			}, $timerSpeed);
		}

		/**
		 * Will only run if data-stale is not present.
		 * 
		 * rlebo - 10/20/2020
		 */
		if ($('.tab-wrap').data('stale') == undefined) {
			startRotate();
			// console.log('started');
		}

		$('.tab-select, .module.background-content').on('mouseenter', function () {
			$pauseTimer = true;
			// console.log('paused');
		});
		$('.tab-select, .module.background-content').on('mouseleave', function () {
			$pauseTimer = false;
			// console.log('running');
		});
	},
	rotate: function () {
		var $gallery, $current, $slide;

		$gallery = $('.tab.is-active .gallery');
		$current = $gallery.find('.slide.is-active');
		$slide = $gallery.find('.slide');

		$('.tab .gallery .slide').removeClass('is-active');
		$slide.eq(0).addClass('is-active');

		if ($current.next().length) {
			$slide.removeClass('is-active');
			$current.next().addClass('is-active');
		} else {
			$slide.removeClass('is-active');
			$slide.eq(0).addClass('is-active');
		}
	},
	gallery_rotate: function () {
		var $gallery, $current, $slide;

		$gallery = $('.tab.is-active .gallery');
		$current = $gallery.find('.slide.is-active');
		$slide = $gallery.find('.slide');

		$('.tab .gallery .slide').removeClass('is-active');
		$slide.eq(0).addClass('is-active');
		if ($slide.length > 1) {
			$tabbed_content.rotateHandler = setInterval($tabbed_content.rotate, 5500);
		}
	},
	init: function () {
		$tabbed_content.load();
		$tabbed_content.action();
		$tabbed_content.auto_rotate_content();
	}
}
$scrolled_content = {
	action: function () {
		var $menu, $menu_height, $menu_scrollHeight, $main, $main_height, $main_scrollHeight;
		// tab scroll
		// $('.content-scroll').hide();
		$('.tab').each(function () {
			var $height, $scrollHeight;

			$height = $(this).find('.tab-content').outerHeight();
			$scrollHeight = $(this).find('.tab-content').prop('scrollHeight');
			// console.log($height+'height'+' '+$scrollHeight+'scrollheight');
			if (($scrollHeight - 20) > $height) {
				// $(this).find('.content-scroll').fadeIn();
			} else {
				// $(this).find('.content-scroll').fadeOut();
			}
		});
		$('.tab-content').on('scroll', function () {
			// var $scroll;

			// $scroll = $(this).scrollTop();

			// if ($scroll <= 1) {
			// 	$(this).parent('.tab').find('.content-scroll').fadeIn();
			// } else {
			// 	$(this).parent('.tab').find('.content-scroll').fadeOut();
			// }
		});
		// main scroll
		$menu = $('.tab-menu-names');
		$menu_height = $menu.outerHeight();
		$menu_scrollHeight = $menu.prop('scrollHeight');
		if (($menu_scrollHeight - 20) > $menu_height) {
			// $menu.next('.content-scroll').fadeIn();
		} else {
			// $menu.next('.content-scroll').fadeOut();
		}
		$menu.on('scroll', function () {
			// $scroll = $(this).scrollTop();
			// if ($scroll <= 1) {
			// 	$(this).next('.content-scroll').fadeIn();
			// } else {
			// 	$(this).next('.content-scroll').fadeOut();
			// }
		});
		$main = $('.main-content-wrap');
		$main_height = $main.outerHeight();
		$main_scrollHeight = $main.prop('scrollHeight');
		if (($main_scrollHeight - 20) > $main_height) {
			// $main.next('.content-scroll').fadeIn();
		} else {
			// $main.next('.content-scroll').fadeOut();
		}
		$main.on('scroll', function () {
			// $scroll = $(this).scrollTop();
			// if ($scroll <= 1) {
			// 	$(this).next('.content-scroll').fadeIn();
			// } else {
			// 	$(this).next('.content-scroll').fadeOut();
			// }
		});
	},
	init: function () {
		$scrolled_content.action();
	}
}
$flyout_menu = {
	open_modal: function () {
		$('body').on('click', 'header .flyout-menu a, a.flyout-menu, .mobile-nav .flyout-menu a', function (e) {
			e.preventDefault();

			// Calendly.initPopupWidget({url: 'https://calendly.com/synapse_results'});

			// HubSpot - Embed Meeting
			// var hsmeeting = new Fancybox(
			// 	[
			// 		{
			// 			src: 'https://synapsemarketingsolutions.com/meetings/ashleighmason/synapse-introduction?embed=true',
			// 			type: 'iframe',
			// 			compact: true,
			// 			preload: true,
			// 			defaultDisplay: 'flex',
			// 			hideScrollbar: true,
			// 			width: 800,
			// 			toggleZoom: 'zoomToFit',
			// 		},
			// 	],
			// 	{
			// 	  // Your custom options
			// 	}
			// 	);

			// Convert redirect to embeded HubSpot meeting page.
			window.location = '/meet-ashleigh-mason/';
			return false;

/* DISABLE FOR CALENDLY
			var $link_href = $(this).attr('href');
			if (typeof $link_href !== 'undefined' && $link_href !== false) {
				var $flyout_name = $link_href.replace('#','').replace('%20', ' ');
			} else {
				var $flyout_name = "";
			}
			// var $flyout_hash = $(this).attr('href');
			// if ($flyout_hash) {
			// 	$flyout_name = $flyout_hash.replace('#', '').replace('%20', ' ');
			// } else {
			// 	$flyout_name = $(this).text();
			// }
			// console.log($flyout_name);

			$('[data-flyout-name]').removeClass('is-active');
			$('body').addClass('flyout-active');
			$('[data-flyout-name="' + $flyout_name + '"]').addClass('is-active');
			$('[data-flyout-name="' + $flyout_name + '"]').focus();
*/
		});
	},
	close_modal: function () {
		$('body').on('click', '.flyout-bg, .flyout-close', function () {
			$(this).parents('.flyout').removeClass('is-active');
			$('body').removeClass('flyout-active');
		});
	},
	load_flyout: function () {
		var $hash;

		$hash = window.location.hash;
		if ($hash) {
			$('a[href="' + $hash + '"]').trigger('click');
		}
	},
	init: function () {
		$flyout_menu.open_modal();
		$flyout_menu.close_modal();
		$flyout_menu.load_flyout();
	}
}
var flyout_controller = {
	init: function(){
		$('body').on('click', 'a.flyout-menu-ajax', function(e){
			e.preventDefault();
			var $link_href = $(this).attr('href');
			var $flyout_name = $link_href.replace('#','').replace('%20', ' ');
			flyout_controller.load($flyout_name);
		});
		flyout_controller.hash_load();
	},
	hash_load: function(){
		var $hash;
		$hash = window.location.hash;
		if ($hash) {
			//var $flyout_name = $hash.replace('#','').replace('%20', ' ');
			$('a[href="' + $hash + '"]').trigger('click');
		}
	},
	load: function(name){
		var $root = $('.bio-flyout-container .flyout.bio-flyout');
		var bio_content = flyout_content[name];
		$root.find('.flyout-header h2').html(bio_content.name);
		$root.find('.flyout-header span').html(bio_content.title);
		$root.find('.flyout-main').html(bio_content.image + bio_content.bio);

		$('[data-flyout-name]').removeClass('is-active');
		$('body').addClass('flyout-active');
		$root.addClass('is-active').focus();
	}
};
$forms = {
	contact_form: function () {
		$('.wpcf7').on('wpcf7:mailsent wpcf7mailsent', function (e) {
			$(this).find('.contact-form').hide();
			$(this).find('.form-thankyou').fadeIn();
			// alert('fired');
		});
	},
	init: function () {
		$forms.contact_form();
	}
}
$nav = {
	action: function () {
		$('header #menu-main-navigation-1 > li').each(function () {
			var $offset, $li_left, $child_submenu, $child_submenu_width, $grandchild_submenu, $grandchild_submenu_width, $win_width;

			$offset = $(this).offset();
			$li_left = $offset.left;
			$child_submenu = $(this).find('> .sub-menu');
			$child_submenu_width = $child_submenu.width();
			$grandchild_submenu = $child_submenu.find('.sub-menu');
			$grandchild_submenu_width = $grandchild_submenu.width();
			$win_width = win.width();
			// console.log('left offset = '+$li_left);
			// console.log('child width = '+$child_submenu_width);
			// console.log('grand child width = '+$grandchild_submenu_width);
			// console.log('Window Width = '+$win_width);
			// console.log('combined = '+($li_left + $child_submenu_width + $grandchild_submenu_width));
			if (($li_left + $child_submenu_width + $grandchild_submenu_width) > $win_width) {
				$(this).addClass('left');
			}

		});
	},
	init: function () {
		$nav.action();
	}
}
$mobile_nav = {
	open: function () {
		$('body').on('click', '.mobile-btn-open', function () {
			if (!$(this).hasClass('is-active')) {
				$(this).addClass('is-active');
				$('.mobile-nav').addClass('is-active');
				$('body').addClass('screen-lock');
				$('.mobile-nav-content[data-status="is-active"] .main-nav .menu > li').velocity('transition.fadeIn', {
					duration: 500,
					delay: 50,
					stagger: 150,
					drag: false
				});
			} else {
				$(this).removeClass('is-active');
				$('.mobile-nav').removeClass('is-active');
				$('body').removeClass('screen-lock');
			}
		});
	},
	close: function () {
		$('body').on('click', '.mobile-nav-bg, .mobile-nav .flyout-menu a', function () {
			$('.mobile-btn-open').trigger('click');
		});
	},
	build_menu: function () {
		// this menu depends on WPs unique IDs for LIs
		$('.mobile-nav .menu-item-has-children').each(function (i) {
			var $id, $html;

			$id = $(this).attr('id');
			console.log($id);
			$(this).append('<button role="button" aria-label="Submenu" data-menu-index="' + $id + '"></button>');
			$(this).attr('data-menu-index', $id);
			$html = $(this).find('.sub-menu').html();
			$html = '<div class="mobile-nav-content submenu" data-status="" data-index="' + $id + '"><div class="button-wrap"><button class="back">Back</button></div><nav class="main-nav"><ul>' + $html + '</ul></nav></div>';
			$('.mobile-nav').append($html);
		});
		// add back buttons to submenu flyouts
		$('[data-index] .menu-item-has-children').each(function (i) {
			var $id;

			$id = $(this).attr('id');
			$(this).append('<button role="button" aria-label="Submenu" data-menu-index="' + $id + '"></button>');
		});
		// open menu
		$('body').on('click', '.mobile-nav button[data-menu-index]', function () {
			var $index;

			$index = $(this).data('menu-index');
			$('[data-index="' + $index + '"]').attr('data-status', 'is-active');
			$('[data-index="' + $index + '"] .main-nav > ul > li').velocity('transition.fadeIn', {
				duration: 500,
				delay: 50,
				stagger: 150,
				drag: false
			});
		});
		// back button
		$('body').on('click', '.mobile-nav button.back', function () {
			$(this).parents('.mobile-nav-content').attr('data-status', '');
		});
	},
	init: function () {
		$mobile_nav.open();
		$mobile_nav.close();
		$mobile_nav.build_menu();
	}
}
$sliders = {
	action: function () {
		// $('.test').slick({
		// infinite: true,
		// slidesToShow: 1,
		// dots: false,
		// arrows: false,
		//  slidesToShow: 1,
		//   slidesToScroll: 1,
		// autoplay: true,
		// autoplaySpeed: 2000,
		// fade: true,
		// cssEase: 'linear'
		// });
		// $('.test').slick();
	},
	init: function () {
		$sliders.action();
	}
}
$sitemap = {
	action: function () {
		$('#menu-sitemap .menu-item-has-children').on('click', function (e) {
			e.preventDefault();
		});
	},
	init: function () {
		$sitemap.action();
	}
}
$filterMenu = {
	$form: null,
	velocity: null,
	getPost: function ($page_number, hashes2) {

		if(this.velocity !== true){
			$('.post').velocity('transition.fadeOut', {
				duration: 500,
				stagger: 250,
				drag: true,
				begin: function(){
					$filterMenu.velocity = true;
					console.log('begin');
				},
				complete: function(){
					$filterMenu.velocity = false;
					console.log('complete');
				}
			});
		}

		if ($('#filter-menu').length) {
			var $url, $form;
			
			$url = window.location.href;
			if ($page_number) {
				$form = '/wp-admin/admin-ajax.php?' + this.$form.serialize() + '&paged=' + $page_number;
			} else {
				$form = '/wp-admin/admin-ajax.php?' + this.$form.serialize();
			}
			$.get($form, function (data) {
				// console.log(data);
				$.each(data.data, function (key, value) {
					existing_height = false;
					if(key == '#post-wrap'){
						var existing_height = $(key).find('.post-row').height();

					}
					$(key).html(value);
					if(
						key == '#post-wrap'
						&& existing_height
					){
						$(key).find('.post-row').css('min-height', existing_height + 'px');

					}
				})
				if($filterMenu.velocity === true){
					$filterMenu.velocity = false;
				}
				this.loadIn();
			}.bind(this));
			setTimeout(function () {
				$scrolled_content.action();
				$('#post-wrap').find('.post-row').css('min-height', '');
			}, 2000);
		}

	},
	loadIn: function () {

		// on load query string
		function getUrlVars() {
			var vars = [],
				hash;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			//console.log(hashes);
			for (var i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');

				if ($.inArray(hash[0], vars) > -1) {
					vars[hash[0]] += "," + hash[1];
				} else {
					vars.push(hash[0]);
					vars[hash[0]] = hash[1];
				}
			}

			return vars;
		}
		var cat_name = getUrlVars()['category_name'];
		// console.log(getUrlVars());
		// console.log(cat_name);
		if (cat_name) {
			var categories = cat_name.split(',');
			categories.forEach(function (e) {
				e = e.replace('-', ' ');
				$('.filter input[data-name="' + e + '"]').trigger('click');
				// $('.filter input[data-name="'+e+'"]').prop('checked', true).parent('.checkbox-wrap').addClass('checked');
				// $('.filter .checkbox-wrap.checked').trigger('click');
			});
		} else {

		}

		$('.post').velocity('transition.slideDownIn', {
			duration: 1500,
			delay: 200,
			stagger: 250,
			drag: true
		});
		setTimeout(function () {
			$scrolled_content.action();
		}, 1000);
	},
	pagination: function () {
		$('body').on('click touchstart', '.pagination li a', function (e) {
			e.preventDefault();
			if ($(this).parents('li').attr('data-number')) {
				var $page_number = $(this).parent('li').data('number');
			} else {
				var $page_number = $(this).attr('href');
				var $page_number = $page_number.split("=").pop();
				if(isNaN($page_number)){
					$page_number = $(this).attr('href');
					var page_pattern = /page\/(\d+)\/*\?*/;
					var matches = $page_number;
					var found = matches.match(page_pattern);
				    if(typeof found[1] !== 'undefined'){
						$page_number = Number(found[1]);
					}
				}
			}

			var url_query = '?' + $('#filter-menu').serialize();
			var url_query = url_query.replace(/\%5B\%5D/g, '').replace(/\+/g, '-');
			var url_query = url_query + '&page=' + $page_number;
			history.pushState('', '', url_query);
			var height = $('.post-row').height();
			$('.post-row').css('min-height', height + 'px');
			$filterMenu.getPost($page_number);
		});
	},
	show_filter: function () {

		// show filter
		$('.show-filter-menu').on('click touchstart', function () {
			$('.filter-menu').addClass('is-active');
		});

	},
	hide_filter: function () {
		// hide filters
		$('.hide-filters, .filter-bg').on('click touchstart', function (e) {
			e.preventDefault();
			$('.filter-menu').removeClass('is-active');
		});
	},
	clear_filters: function () {
		// clear all filters
		$('.clear-filters').on('click touchstart', function (e) {
			e.preventDefault();
			$('button[data-filter]').remove();
			$(this).parents('.filter-menu').find('.checkbox-wrap.checked').trigger('click');
			$(this).parents('.filter-menu').find('.checkbox-wrap').removeClass('checked');
			$filterMenu.getPost();
		});
	},
	hide_show_category: function () {
		// collapse filter menu group
		$('.hide-show').on('click touchstart', function () {
			$(this).parents('.filter').toggleClass('is-closed');
		});
	},
	see_more: function () {
		// see more
		var $count, $seeMore, $title;
		if ($('.filter').length) {
			$('.filter').each(function () {
				$count = $(this).find('input[type="checkbox"]').length;
				$title = $(this).find('.title').text();
				$seeMore = '<button class="see-more">See More</button>';
				if ($count > 5) {
					$(this).find('input[type="checkbox"]').eq(4).parents('label').nextAll('label').addClass('is-hidden');
					$(this).find('input[type="checkbox"]').eq(4).parents('label').after($seeMore);
				}
			});
		}
		$('body').on('click touchstart', '.see-more', function () {
			$(this).nextAll('label').removeClass('is-hidden');
			$(this).remove();
		});
	},
	action: function () {

		// topfilter bar remove single filters

		$('body').on('click touchstart', 'button[data-filter]', function () {
			var data_filter = $(this).data('filter').split('-');
			var data_name = $(this).data('filter');
			$('button[data-filter="' + data_name + '"]').remove();
			// console.log(data_filter[0]);
			$('.filter-menu input[data-name="' + data_filter[0] + '"]').prop('checked', false);
			$('.filter-menu input[data-name="' + data_filter[0] + '"]').parent('.checkbox-wrap').removeClass('checked');
			var url_query = '?' + $('#filter-menu').serialize();
			var url_query = url_query.replace(/\%5B\%5D/g, '').replace(/\+/g, '-');
			history.pushState('', '', url_query);
			$filterMenu.getPost();
		});

		// apply fillters
		$('.apply-filters').on('click touchstart', function (e) {
			e.preventDefault();
			$('.filter-menu').removeClass('is-active');

			var url_query = '?' + $('#filter-menu').serialize();
			// console.log(url_query);
			var url_query = url_query.replace(/\%5B\%5D/g, '').replace(/\+/g, '-');
			history.pushState('', '', url_query);

			$filterMenu.getPost(); 
		});

		// add button to top filter bar
		$('body').on('click touchstart', '.filter input[type="checkbox"]', function () {
			var $obj = $(this).parents('label');
			var text = $obj.find('span').text();
			var text_sani = text.toLowerCase().replace(' ', '-');
			var id = $obj.index();
			if ($('[data-filter="' + text + '-' + id + '"]').length) {
				$('[data-filter="' + text + '-' + id + '"]').remove();
			} else {
				$('.filter-topbar .applied-filters').append('<button data-slug="' + text_sani + '" data-filter="' + text + '-' + id + '">' + text + '<span class="remove"></span></button>');
			}
		});

	},
	init: function () {
		this.$form = $('#filter-menu');
		// this.getPost();
		$filterMenu.pagination();
		$filterMenu.action();
		$filterMenu.show_filter();
		$filterMenu.hide_filter();
		$filterMenu.hide_show_category();
		$filterMenu.clear_filters();
		$filterMenu.see_more();
	}
}
var results_filter_controller = {
	form_selector: '#filter-menu',
	base_url: '/wp-admin/admin-ajax.php',
	loadIn: function () {

		// on load query string
		function getUrlVars() {
			var vars = [],
				hash;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			//console.log(hashes);
			for (var i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');

				if ($.inArray(hash[0], vars) > -1) {
					vars[hash[0]] += "," + hash[1];
				} else {
					vars.push(hash[0]);
					vars[hash[0]] = hash[1];
				}
			}

			return vars;
		}
		var url_vars = getUrlVars();
		var service_name = url_vars['service_name'];
		var industry_name = url_vars['industry_name'];
		// console.log(getUrlVars());
		// console.log(cat_name);
		var changes = [];
		if (service_name) {
			var $services = jQuery('#filter-menu select[name="service_name"]');
			if(service_name != null){
				$services.val(service_name);
				changes.push($services);
			}
		} 
		if (industry_name) {
			var $industries = jQuery('#filter-menu select[name="industry_name"]');
			if(industry_name != null){
				$industries.val(industry_name);
				changes.push($industries);
			}
		}
		$.each(changes, function (key, value) {
			value.trigger('change');
		});

		$('.post').velocity('transition.slideDownIn', {
			duration: 1500,
			delay: 200,
			stagger: 250,
			drag: true
		});
		setTimeout(function () {
			$scrolled_content.action();
		}, 1000);
	},
	submit: function(){
		var selector = this.form_selector
		var $form = jQuery(selector);

		var data = $form.serialize();

		$('.post').velocity('transition.fadeOut', {
			duration: 500,
			stagger: 250,
			drag: true
		});
		var url_query = '?' + $('#filter-menu').serialize();
		// console.log(url_query);
		var url_query = url_query.replace(/\%5B\%5D/g, '').replace(/\+/g, '-');
		history.pushState('', '', url_query);

		var url = this.base_url + '?' + data;
		$.get(url, function (data) {
			// console.log(data);
			$.each(data.data, function (key, value) {
				existing_height = false;
				if(key == '#post-wrap'){
					var existing_height = $(key).find('.post-row').height();

				}
				$(key).html(value);
				if(
					key == '#post-wrap'
					&& existing_height
				){
					$(key).find('.post-row').css('min-height', existing_height + 'px');

				}
			})
			this.loadIn();
		}.bind($filterMenu));
		setTimeout(function () {
			$scrolled_content.action();
			$('#post-wrap').find('.post-row').css('min-height', '');
		}, 2000);
	},
	bind: function(){
		var selector = this.form_selector;
		var $form = jQuery(selector);
		$form.on('change', 'select', function(){
			this.submit();
		}.bind(this));
		$form.on('click touchstart', '.clear-filters', function(){
			$form.find('select option').prop('selected', false);
			$form.find('select').trigger('change');
			//this.submit();
		}.bind(this));
		//this.loadIn();
	}
};

jQuery(document).ready(function(){
	results_filter_controller.bind();
});
$loadIn = {
	action: function () {
		if (win.width() > 1024) {
			$('.main-content').velocity({
				translateX: "0",
				duration: 1200,
				drag: false
			});
		} else {
			$('.main-content').velocity({
				translateY: "0",
				duration: 1200,
				drag: false
			});
		}
		$('#menu-main-navigation-1 > *').velocity('transition.slideDownIn', {
			duration: 500,
			stagger: 50,
			drag: false
		});
		// $('.main-content-wrap, .light-arrow .tab-select').velocity( 'transition.fadeIn', { duration: 1200, delay: 700, stagger : 150, drag : false });
		$('.main-content-wrap').velocity('transition.fadeIn', {
			duration: 1200,
			stagger: 150,
			drag: false
		});
		$('.tab-name > div').velocity('transition.slideDownIn', {
			duration: 1000,
			stagger: 150,
			drag: false
		});

		$('.background-content').velocity({
			opacity: '1',
		}, {
			duration: 300,
			easing: 'easeInQuad'
		});
		$('.gallery').velocity({
			opacity: '1',
		}, {
			duration: 300,
			delay: 500,
			easing: 'easeInQuad'
		});

		$('.post-wrap').velocity({
			opacity: '1',
		}, {
			duration: 300,
			delay: 500,
			easing: 'easeInQuad'
		});

		$('.post').velocity('transition.slideDownIn', {
			duration: 1500,
			delay: 200,
			stagger: 250,
			drag: true
		});
	},
	init: function () {
		$loadIn.action();
	}
}

/*************************************************************************************
 * Call functions on Doc Ready
 *************************************************************************************/
doc.ready(function () {

	$tabbed_content.init();
	$scrolled_content.init();
	$flyout_menu.init();
	$forms.init();
	$nav.init();
	$mobile_nav.init();
	$sitemap.init();
	$filterMenu.init();
	flyout_controller.init();
	// $sliders.init();
	$loadIn.init();

	//show or hide scroll icons for content
	var leftContentHeight = parseInt($(".main-content-wrap").prop("scrollHeight"));
	var leftDivHeight = parseInt($(".main-content-wrap").prop("offsetHeight"));
	var rightContentHeight = parseInt($(".tab-content").prop("scrollHeight"));
	var rightDivHeight = parseInt($(".tab-content").prop("offsetHeight"));

	if(leftContentHeight <= leftDivHeight){
		$(".content-scroll-left").css("display","none");
	}

	if(rightContentHeight <= rightDivHeight){
		$(".content-scroll-right").css("display","none");
	}
}); //Doc Ready


/*************************************************************************************
 * Call Functions that do need to be called on resize
 *************************************************************************************/
win.resize(function () {
	/*
	waitForFinalEvent(function(){


    }, 500, "resize");
    */
}).resize();


/*************************************************************************************
 * Call Functions that do need to be called on resize
 *************************************************************************************/
win.scroll(function () {

});

$(window).on('load resize', function () {
	var $headerH;
	if (!$('.posts').length) {
		$scrolled_content.action();
	}
	$headerH = $('header').height();
	if ($(window).width() <= 1023) {
		if ($('body').hasClass('single-syn_results')) {
			// console.log('test');
		} else {
			$('.tab-select-name').on('click', function (e) {
				// console.log('click');
				e.preventDefault();
				// $('html, body').animate({
				// 	scrollTop: $('.tabbed-content').offset().top - $headerH - 75
				// }, 250);
			});
		}
	}
	if (window.width <= 1023) {
		// $tabbed_content.mobile_tab_select_fix();
	}
});